<template>
    <div class="form-view">
        <section>
            <h2 v-if="!company.id" class="text-center">Tilføj virksomhed</h2>
            <h2 v-else class="text-center">Rediger virksomhed</h2>
            <div v-if="!existingCompany">
                <div class="form">
                    <div class="grid-x">
                        <div class="large-1 medium-1 small-1 cell flexbox-center">
                            <icon class="small-svg fill-dark-gray" name="envelope" />
                        </div>
                        <div class="large-3 medium-3 small-3 cell border-bottom">
                            <p class="custom-modal-text-alignment">E-mail</p>
                        </div>
                        <div class="auto cell border-bottom">
                            <email-validation :newUser="newUser" :autofocus="true" v-model="company.email" @validateEmail="validEmailResult" />
                        </div>
                    </div>
                </div>
                <div class="relative">
                    <div v-if="checkingUserFeedback" class="checking-user-existing-feedback">
                        <div class="spinner-container spinner-container-modal">
                            <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="form">
                    <div class="grid-x">
                        <div class="large-1 medium-1 small-1 cell flexbox-center">
                            <icon class="user small-svg fill-dark-gray" name="building" />
                        </div>
                        <div class="large-3 medium-3 small-3 cell border-bottom">
                            <p class="custom-modal-text-alignment">Navn</p>
                        </div>
                        <div class="auto cell border-bottom">
                            <input type="text" v-model="company.name" :disabled="validateEmailField()" />
                        </div>
                    </div>
                </div>

                <div class="form">
                    <div class="grid-x">
                        <div class="large-1 medium-1 small-1 cell flexbox-center">
                            <icon class="small-svg fill-dark-gray" name="location" />
                        </div>
                        <div class="large-3 medium-3 small-3 cell border-bottom">
                            <p class="custom-modal-text-alignment">Adresse</p>
                        </div>
                        <div class="auto cell border-bottom">
                            <div id="dawaResults" class="autocomplete-container">
                                <vue-dawa ref="dawaInput" id="dawaInput" @select="selectAddress($event, 'addressObject')"
                                    :val="addressObject.oneLineAddress"
                                    :showMax="10"
                                    placeholder=""
                                    containerId="#dawaResults"
                                    :options="{adgangsadresserOnly: true}"
                                    fieldId="#dawaInput">
                                </vue-dawa>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form">
                    <div class="grid-x">
                        <div class="large-1 medium-1 small-1 cell flexbox-center">
                            <icon class="small-svg fill-dark-gray" name="phone" />
                        </div>
                        <div class="large-3 medium-3 small-3 cell border-bottom">
                            <p class="custom-modal-text-alignment">Telefon</p>
                        </div>
                        <div class="auto cell border-bottom">
                            <input type="text" v-model="company.phoneNumber" :disabled="validateEmailField()" />
                        </div>
                    </div>
                </div>

                <div class="form">
                    <div class="grid-x">
                        <div class="large-1 medium-1 small-1 cell flexbox-center">
                            <icon class="small-svg fill-dark-gray" name="bubble" />
                        </div>
                        <div class="large-3 medium-3 small-3 cell border-bottom flexbox-align-items border-bottom-last">
                            <p class="custom-modal-text-alignment">Note</p>
                        </div>
                        <div class="auto cell border-bottom border-bottom-last">
                            <textarea rows="4" cols="30" v-model="company.note" :disabled="validateEmailField()"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="existingCompany && !checkingUserFeedback" class="user-existing-info-container">
                <div class="grid-x flexbox-justify-content-center cell user-existing-info-header">
                    <span>En virksomhed findes allerede med e-mail:</span>
                    <span>{{company.email}}</span>
                </div>
                <div class="grid-x">
                    <div class="cell user-existing-info">
                        <div class="grid-x user-existing-info-profile">
                            <icon class="huge-svg fill-primary" name="building" />
                        </div>
                        <div class="grid-x user-existing-info-name" style="font-weight: 500; margin-bottom: 35px; font-size: 1.1rem; text-align: center;">
                            <span>{{existingCompany.name}}</span>
                        </div>
                        <div class="grid-x user-existing-info-text">
                            <icon class="small-svg fill-primary" name="phone" />
                            <span>{{existingCompany.phoneNumber}}</span>
                        </div>
                        <div class="grid-x user-existing-info-text">
                            <icon class="small-svg fill-primary" name="envelope" />
                            <span>{{existingCompany.email}}</span>
                        </div>
                    </div>
                </div>
                <div class="grid-x" style="margin-top: 70px; display: flex; justify-content: center;">
                    <span>Du har mulighed for at tilknytte den eksisterende virksomhed til <span style="font-weight: 500; text-transform: uppercase;">{{selectedOrganization.name}} </span> eller oprette en ny bruger</span>
                </div>
            </div>
            <div v-if="!existingCompany" class="text-center buttons-modal">
                <a :class="{'disabled': validateFields()}" @click="createUpdateOrganization()">
                    <span v-if="!company.id">Tilføj</span>
                    <span v-else>Gem</span>
                </a>
                <a @click="closeModal()">Fortryd</a>
            </div>
             <div v-else class="text-center buttons-modal">
                <a @click="useExistingCompany()">Brug eksisterende</a>
                <a @click="useNewCompany()">Opret ny</a>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VueDawa from 'vue-dawa'
import emailValidation from './../../shared/email/email-validation.vue'

export default {
    name: 'settings-modal-company',
    props: [
        'data'
    ],
    components: {
        'vue-dawa': VueDawa,
        'email-validation': emailValidation
    },
    data () {
        return {
            selectedAddress: false,
            addressObject: {
                oneLineAddress: ''
            },
            validEmail: true,
            checkingUserFeedback: false,
            newUser: false
        }
    },
    computed: {
        ...mapGetters({
            selectedOrganization: 'getSelectedOrganization',
            existingCompany: 'getCompanyExist',
            companies: 'getAssociatedOrganizationList',
            company: 'getCompany'
        })
    },
    methods: {
        ...mapActions({
            setCreateOrganization: 'setCreateOrganization',
            setCompanyExist: 'setCompanyExist',
            setClearCompanyExist: 'setClearCompanyExist',
            setCompany: 'setCompany'
        }),
        translateAddressData (address) {
            if (!address || !address.data) {
                return
            }
            return {
                id: address.data.id,
                street: address.data.vejnavn,
                href: address.data.href,
                streetNumber: address.data.husnr,
                floor: address.data.etage,
                door: address.data.dør,
                zipCode: address.data.postnr,
                city: address.data.postnrnavn,
                secondStreet: address.data.supplerendebynavn,
                oneLineAddress: address.tekst,
                type: address.type
            }
        },
        selectAddress (payload, objectName) {
            this.selectedAddress = true
            this.addressObject = this.translateAddressData(payload)
        },
        useExistingCompany () {
            this.setCompany(this.existingCompany)
            this.setClearCompanyExist()
        },
        useNewCompany () {
            this.setCompany('')
            this.setClearCompanyExist()
        },
        closeModal () {
            this.$emit('close')
        },
        validateFields () {
            if (!this.company.name || !this.company.email || !this.company.phoneNumber || !this.validEmail || this.checkingUserFeedback) {
                return true
            } else {
                return false
            }
        },
        validateEmailField () {
            if (!this.company.email || (this.company.email && !this.validEmail)) {
                if (this.$refs.dawaInput) {
                    this.$refs.dawaInput.$refs.input.setAttribute('disabled', '')
                }
                return true
            } else {
                if (this.$refs.dawaInput) {
                    this.$refs.dawaInput.$refs.input.removeAttribute('disabled')
                }
                return false
            }
        },
        validEmailResult (result) {
            let mailValid = false

            if ((result === null || result) && !this.existingCompany) {
                mailValid = true
            } else {
                mailValid = false
            }

            if (result && !this.data && this.company.email) {
                this.checkingUserFeedback = true
                if (this.companies.filter(company => company.email === this.company.email).length > 0) {
                    this.$notify({group: 'info', type: 'warn', title: '', text: 'En virksomhed med samme e-mail er allerede oprettet i ' + this.selectedOrganization.name + '. Brug en anden e-mail'})
                    this.checkingUserFeedback = false
                    mailValid = false
                } else {
                    new Promise((resolve, reject) => {
                        resolve(this.setCompanyExist(this.company.email))
                    }).then(() => {
                        this.checkingUserFeedback = false
                    })
                }
            }
            this.validEmail = mailValid
        },
        createUpdateOrganization () {
            if (this.addressObject.oneLineAddress !== '') {
                this.company.address1 = this.addressObject.street + ' ' + this.addressObject.streetNumber
                this.company.city = this.addressObject.city
                this.company.postalCode = this.addressObject.zipCode
            }
            new Promise((resolve, reject) => {
                resolve(this.setCreateOrganization(this.company))
            }).then((response) => {
                if (response.status === 200) {
                    this.$emit('close')
                }
            })
        }
    },
    created () {
        if (this.company.id) {
            const company = Object.assign({}, this.company)
            if (company.address1) {
                this.addressObject.oneLineAddress = company.address1
            }
            if (company.postalCode) {
                this.addressObject.oneLineAddress += ', ' + company.postalCode

                if (company.city) {
                    this.addressObject.oneLineAddress += ' ' + company.city
                }
            }
        } else {
            this.newUser = true
        }
    },
    mounted () {
        if (this.company.id) {
            this.$refs.dawaInput.$refs.input.setAttribute('disabled', '')
        }
        this.validateEmailField()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/administration/administration-modal-company.vue